<template>
    <div class="insert-rec insert-article article-onepic">  
    <a :href="cardInfo.url" target="_blank" class="insert-box insert-article__box" :data-spm-data="cardInfo.spm">
        <div class="img-box img-do">
            <img class="insert-article__img" :src="cardInfo.cover" alt="配图">
        </div>
        <div class="insert-article__content">
            <h5 class="insert-rec__title insert-article__title">{{cardInfo.title}}</h5>
            <p class="insert-article__des">{{cardInfo.brief}}</p>
            <p class="insert-article__footer">
            <span class="auther" v-if="cardInfo.author"><span>作者：</span>{{cardInfo.author}}</span>
            </p>
        </div>
    </a>
    <div style="clear: both"></div>
</div>
</template>

<script>

export default {
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    
}
</script>

<style lang="less" scoped>

</style>